// extracted by mini-css-extract-plugin
module.exports = {"panel":"language-panel_panel__1kyyz","header":"language-panel_header__3cO3g","body":"language-panel_body__IWAjz","current":"language-panel_current__QbK73"};